export { RoomsV2Connected as RoomsV2 } from './container';
